import { Form, Select } from 'antd'
import { FC } from 'react'
import { Polymer } from '../../../../../types/api/form'

const polymerOptions = Object.values(Polymer).map(value => ({
    value,
    label: value,
}))

const PolymerField: FC = () => {
    return (
        <Form.Item label={'Полимер'} name={'polymer'}>
            <Select
                allowClear
                placeholder='Полимер'
                options={polymerOptions}
                style={{ minWidth: 160 }}
            />
        </Form.Item>
    )
}

export default PolymerField
